import React, { Component } from 'react';
import PropTypes from 'prop-types'

export default class BannerNavMenu extends Component {
  static propTypes = {
    menuList: PropTypes.array.isRequired
  };
  // mutiMenu(data, key) {
  //   return (
  //     <SubMenu
  //       key={key}
  //       title={<span> {data.Name} </span>}
  //       className='menu_nav'>
  //       {data.Childs.map((item, i) => {
  //         if (item.Valid !== 1) {
  //           return ''
  //         };
  //         return <Menu.Item style={{ float: "none" }} key={key + i}><a href={item.Url} target={item.OpenType ? '_self' : '_blank'} >{item.Name}</a></Menu.Item>
  //       })}
  //     </SubMenu>
  //   )
  // }
  renderMenuItem(menuList) {
    menuList = menuList ? menuList : []
    return menuList.map((item, index) => {
      if (item.Valid !== 1) {
        return ''
      };
      if (item.Childs.length > 0) {
        return null;
      } else {
        return (
          <li key={index} className='menu_nav'>
            <a href={item.Url} target={item.OpenType ? '_self' : '_blank'} >{item.Name}</a>
          </li>
        )
      }
    })
  }
  render() {
    let { menuList = [] } = this.props
    return (
      <div className="home-banner-nav-menu">
        <ul className='menu_nav_ul'>
          {this.renderMenuItem(menuList)}
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/BannerNavMenu.js